import { render, staticRenderFns } from "./AuthenticityCheck.vue?vue&type=template&id=3671bee5&scoped=true"
import script from "./AuthenticityCheck.vue?vue&type=script&lang=js"
export * from "./AuthenticityCheck.vue?vue&type=script&lang=js"
import style0 from "./AuthenticityCheck.vue?vue&type=style&index=0&id=3671bee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671bee5",
  null
  
)

export default component.exports